import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "modal-tittle" }
const _hoisted_2 = { class: "d-flex justify-content-around" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  id: "openNoteModalTc",
  class: "btn tw-bg-[#FF0000] tw-text-[#FFFFFF] tw-rounded-lg fw-bold ms-auto mt-2 me-4",
  style: {"border":"none"},
  "data-bs-toggle": "modal",
  "data-bs-target": "#note-Modal-Tcname"
}, "SEE NOTE", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "COMPANY NAME: ", -1)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"modal\" id=\"note-Modal-Tcname\" tabindex=\"-1\" aria-hidden=\"true\" aria-labelledby=\"label-modal-1\"><div class=\"modal-dialog modal-dialog-centered\"><div class=\"modal-content\"><div class=\"modal-body\"><h3 class=\"text-center\"><b>Note:</b></h3><br><p class=\"text-center\">It is mandatory to put the company name</p><br><div class=\"d-flex justify-content-end\"><button id=\"closeNoteModal\" type=\"button\" class=\"btn tw-bg-[#00a0da] tw-text-[#FFFFFF] tw-rounded-full tw-w-[150px]\" data-bs-dismiss=\"modal\" aria-label=\"Close\"> CLose</button></div></div></div></div></div>", 1)
const _hoisted_7 = { class: "d-flex justify-content-center" }
const _hoisted_8 = { class: "mlo-tables d-flex flex-column px-4 mt-4" }
const _hoisted_9 = { class: "d-flex justify-content-between pb-4 px-4 gap-5 bg-white rounded-4" }
const _hoisted_10 = { class: "pb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "mlo-tables__contenido-15year__tittle text-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold tw-text-[#00a0da]" }, "Title Company Fees and Services Payments")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_13 = { class: "table-mlo w-100 bg-white p-3 rounded-4" }
const _hoisted_14 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", null, "BUYER", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, "%", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, "SELLER", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", null, "%", -1)
const _hoisted_19 = { class: "mlo-tables d-flex flex-column px-4 mt-4" }
const _hoisted_20 = { class: "d-flex justify-content-between pb-4 px-4 gap-5 bg-white rounded-4" }
const _hoisted_21 = { class: "pb-3 w-100" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "mlo-tables_contenido-15year_tittle text-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold tw-text-[#00a0da] fs-4" }, "Other Services Prices")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_24 = { class: "table-mlo w-100 bg-white p-3 rounded-4" }
const _hoisted_25 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", null, "$", -1)
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash" }, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-floppy-o",
  "aria-hidden": "true"
}, null, -1)

import axios from "axios";
import { ref, toRefs, onMounted } from 'vue';
import { useToast } from "@/composables/useToast";
import { environment } from "@/environment";
//VARIABLES

export default /*#__PURE__*/_defineComponent({
  __name: 'TitleCompanyTables',
  props: {
  userID: {
    type: Number,
    default: null,
  },
  addFunction: Function,
  removeFunction: Function,
},
  setup(__props) {

const props = __props;

const toast = useToast();

const url = environment.URL_API;
const loading = ref(false);
const isSaving = ref(false);


const { userID, addFunction, removeFunction } = toRefs(props);

// Main company data
const titleCompanyData = ref({
  ID: null,
  user_id: userID.value,
  name: '',
  phone: '',
  email: '',
  buyer: 0,
  seller: 0,
});

// Create a separate array for other items
const otherItems = ref([
  {
    ID: null,
    item: '',
    cost: 0,
    user_id: userID.value
  }
]);

// Keep track of items that were recently deleted
const recentlyDeletedItems = ref([]);

const getData = async () => {
  if (isSaving.value) return; // Don't refetch while saving

  loading.value = true;
  try {
    const response = await axios.get(
      `${url}company-title?user_id=${userID.value}`
    );

    if (!response.data.error) {
      // Handle main company data
      titleCompanyData.value = response.data.companyTitle
        ? {
          ID: response.data.companyTitle.ID,
          user_id: userID.value,
          name: response.data.companyTitle.name || '',
          phone: response.data.companyTitle.phone || '',
          email: response.data.companyTitle.email || '',
          buyer: response.data.companyTitle.buyer || 0,
          seller: response.data.companyTitle.seller || 0,
        }
        : {
          ID: null,
          user_id: userID.value,
          name: '',
          phone: '',
          email: '',
          buyer: 0,
          seller: 0,
        };

      // Filter out any recently deleted items from the response
      if (response.data.otherItems && response.data.otherItems.length > 0) {
        const newItems = response.data.otherItems.filter(item =>
          !recentlyDeletedItems.value.includes(item.ID)
        );

        if (newItems.length > 0) {
          otherItems.value = newItems;
        } else {
          otherItems.value = [{
            ID: null,
            item: '',
            cost: 0,
            user_id: userID.value
          }];
        }
      } else {
        otherItems.value = [{
          ID: null,
          item: '',
          cost: 0,
          user_id: userID.value
        }];
      }

      // Clear recently deleted items after data refresh
      recentlyDeletedItems.value = [];
    }
  } catch (error) {
    await toast.error("Error loading data", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
  } finally {
    loading.value = false;
  }
};

// Add a new empty item
const addItem = () => {
  otherItems.value.push({
    ID: null, // Will be assigned by the server when saved
    item: '',
    cost: 0,
    user_id: userID.value
  });
};

// Remove an item by index
const removeItem = async (index, ID) => {
  loading.value = true;

  // If item has an ID, call the delete API
  if (ID) {
    try {
      const response = await axios({
        url: `${url}other-items`,
        method: "DELETE",
        data: { ID }
      });

      if (!response.data.error) {
        // Track this ID as recently deleted
        recentlyDeletedItems.value.push(ID);

        // Remove from UI
        otherItems.value.splice(index, 1);

        // If we deleted all items, add an empty one
        if (otherItems.value.length === 0) {
          otherItems.value.push({
            ID: null,
            item: '',
            cost: 0,
            user_id: userID.value
          });
        }

        await toast.success("Item deleted successfully", {
          position: "top-end",
          timer: 2000,
          showCloseButton: true,
        });
      } else {
        await toast.error(response.data.message || "Failed to delete item", {
          position: "top-end",
          timer: 3000,
          showCloseButton: true,
        });
      }
    } catch (error) {
      await toast.error("Error deleting item", {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  } else {
    // For new items without an ID, just remove from the array
    otherItems.value.splice(index, 1);

    // If we deleted all items, add an empty one
    if (otherItems.value.length === 0) {
      otherItems.value.push({
        ID: null,
        item: '',
        cost: 0,
        user_id: userID.value
      });
    }
  }

  loading.value = false;
};

const saveData = async () => {
  loading.value = true;
  isSaving.value = true;

  try {
    const response = await axios({
      url: `${url}company-title`,
      method: "POST",
      data: {
        companyTitle: titleCompanyData.value,
        otherItems: otherItems.value
      }
    });

    if (!response.data.error) {
      // Clear recently deleted items since we've saved
      recentlyDeletedItems.value = [];
      await toast.success(response.data.message || "Data saved successfully", {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
      setTimeout(() => {
        getData();
        // window.location.reload();
      }, 500
      );

    } else {
      await toast.error(response.data.message || "Error saving data", {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  } catch (error) {
    await toast.error("An error occurred while saving data", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
  } finally {
    loading.value = false;
    isSaving.value = false;
  }
};


getData();


return (_ctx: any,_cache: any) => {
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            class: "border border-white",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((titleCompanyData.value.name) = $event))
          }, null, 512), [
            [_vModelText, titleCompanyData.value.name]
          ])
        ])
      ])
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_Loader, { visible: loading.value }, null, 8, ["visible"]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("table", _hoisted_14, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_15,
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((titleCompanyData.value.buyer) = $event))
                        }, null, 512), [
                          [_vModelText, titleCompanyData.value.buyer]
                        ])
                      ]),
                      _hoisted_16
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_17,
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((titleCompanyData.value.seller) = $event))
                        }, null, 512), [
                          [_vModelText, titleCompanyData.value.seller]
                        ])
                      ]),
                      _hoisted_18
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("table", _hoisted_25, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherItems.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((item.item) = $event)
                            }, null, 8, _hoisted_26), [
                              [_vModelText, item.item]
                            ])
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => ((item.cost) = $event)
                          }, null, 8, _hoisted_27), [
                            [_vModelText, item.cost]
                          ])
                        ]),
                        _hoisted_28,
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            class: "btn btn-danger btn-sm ms-2",
                            onClick: ($event: any) => (removeItem(index, item.ID))
                          }, _hoisted_31, 8, _hoisted_29)
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("button", {
                  class: "btn btn-primary px-5 mt-3",
                  onClick: addItem
                }, [
                  _createTextVNode(" Add "),
                  _hoisted_32
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", { class: "d-flex justify-content-center" }, [
      _createElementVNode("button", {
        class: "btn btn-primary px-5 mt-3",
        onClick: saveData
      }, [
        _createTextVNode(" Save Data "),
        _hoisted_33
      ])
    ])
  ], 64))
}
}

})